import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchBooks = (params = {}) => api.get("/books", { params }).then(r => r.data);
export const fetchBook = (id) => api.get(`/books/${id}`).then(r => r.data);
export const fetchAuthors = () => api.get("/authors").then(r => r.data);
export const fetchAuthor = (id) => api.get(`/authors/${id}`).then(r => r.data);
export const fetchNews = () => api.get("/news").then(r => r.data);
export const fetchRecommendations = (params = {}) => api.get("/recommendations", { params }).then(r => r.data);
export const fetchExtracts = (params = {}) => api.get("/extracts", { params }).then(r => r.data);
export const fetchBookExtracts = (bookId) => api.get("/extracts", { params: { book_id: bookId } }).then(r => r.data);
export const fetchExtract = (slug, track = true) => api.get(`/extracts/${slug}`, { params: { track } }).then(r => r.data);
export const whatsappUrl = (number, message) =>
  `https://wa.me/${(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(message || "")}`;
export const extractPublicUrl = (slug, lieu) =>
  `${process.env.REACT_APP_PUBLIC_SITE_URL}/histoires/${slug}${lieu ? `?lieu=${encodeURIComponent(lieu)}` : ""}`;
export const extractShareUrl = (slug, lieu) =>
  `${process.env.REACT_APP_PUBLIC_SITE_URL}/api/share/histoires/${slug}${lieu ? `?lieu=${encodeURIComponent(lieu)}` : ""}`;
export const bookShareUrl = (id) => `${process.env.REACT_APP_PUBLIC_SITE_URL}/api/share/livres/${id}`;
export const partnerPublicUrl = (code) => `${process.env.REACT_APP_PUBLIC_SITE_URL}/p/${code}`;
export const fetchPartner = (code) => api.get(`/partners/${code}`).then(r => r.data);
export const trackPartnerScan = (code) => api.post(`/partners/${code}/scan`).catch(() => {});
export const fetchPlacement = (slug, code) => api.get(`/extracts/${slug}/lieux/${code}`).then(r => r.data);
export const startReadingSession = (body) => api.post("/reading-sessions", body).then(r => r.data);
export const pingReadingSession = (sid, body, beacon = false) => {
  const url = `${API}/reading-sessions/${sid}/ping`;
  if (beacon && navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([JSON.stringify(body)], { type: "application/json" }));
    return;
  }
  api.post(`/reading-sessions/${sid}/ping`, body).catch(() => {});
};
export const trackSessionEvent = (sid, type) => api.post(`/reading-sessions/${sid}/event`, { type }).catch(() => {});
export const sendSessionSurvey = (sid, body) => api.post(`/reading-sessions/${sid}/survey`, body).catch(() => {});
export const subscribeNewsletter = (body) => api.post("/newsletter", body).then(r => r.data);
export const buildWhatsappMessage = (extract, sponsorName, version, extra = {}) => {
  const where = extra.city ? `, retrait à ${extra.city}${extra.pickup ? ` – ${extra.pickup}` : ""}` : "";
  const versionText = version ? `version ${version.name}${version.price ? `, ${version.price}` : ""}${where}` : "";
  let base = (extract.whatsapp_message || "Bonjour, je viens de lire l'histoire [Titre] sur le Distributeur d'extraits littéraires CLED et je souhaite commander le livre ([Version]).")
    .replace(/\[Titre\]/gi, `« ${extract.title} »`);
  if (/\[Version\]/i.test(base)) base = versionText ? base.replace(/\[Version\]/gi, versionText) : base.replace(/\s*\(\[Version\]\)/gi, "").replace(/\[Version\]/gi, "");
  else if (versionText) base = `${base} (${versionText})`;
  if (sponsorName) base = /\.$/.test(base) ? `${base.slice(0, -1)} (Lieu : ${sponsorName}).` : `${base} (Lieu : ${sponsorName})`;
  return extra.ref ? `${base} Réf. : ${extra.ref}` : base;
};
export const newOrderRef = () => `CLED-${Array.from({ length: 5 }, () => "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"[Math.floor(Math.random() * 32)]).join("")}`;
export const sendOrderIntent = (body) => api.post("/orders/intent", body).catch(() => {});
export const fetchPickupPoints = () => api.get("/pickup-points").then(r => r.data);
export const extractVersions = (extract) => {
  const v = [];
  if (extract.paper_available !== false && extract.price_paper_label) v.push({ key: "papier", name: "papier", label: "Version papier", price: extract.price_paper_label });
  if (extract.price_digital_label) v.push({ key: "numerique", name: "numérique", label: "Version numérique", price: extract.price_digital_label });
  if (!v.length) v.push({ key: "livre", name: null, label: "Découvrir le livre complet", price: extract.price_label });
  return v;
};
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/uploads/image", fd, { withCredentials: true, headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data.url);
};
export const EXTRACT_GENRES = [
  { value: "poesie", label: "Poésie" },
  { value: "contes", label: "Contes" },
  { value: "polar", label: "Polar" },
  { value: "roman", label: "Roman" },
  { value: "nouvelle", label: "Nouvelle" },
  { value: "jeunesse", label: "Jeunesse" },
  { value: "histoire", label: "Histoire" },
  { value: "essai", label: "Essai" },
];
export const extractGenreLabel = (v) => EXTRACT_GENRES.find((g) => g.value === v)?.label || (v === "non-renseigne" ? "Non renseigné" : v);
export const submitManuscript = (payload) => api.post("/submissions", payload).then(r => r.data);
export const submitContact = (payload) => api.post("/contacts", payload).then(r => r.data);

export const GENRES = [
  { value: "all", label: "Tous" },
  { value: "general", label: "Général" },
  { value: "roman", label: "Roman" },
  { value: "poesie", label: "Poésie" },
  { value: "jeunesse", label: "Jeunesse" },
  { value: "histoire", label: "Histoire" },
  { value: "contes", label: "Contes" },
];

export const genreLabel = (value) =>
  GENRES.find((g) => g.value === value)?.label || value;

// Catégories spécifiques aux Lectures recommandées (7switch)
export const RECO_GENRES = [
  { value: "all", label: "Tous" },
  { value: "roman", label: "Roman" },
  { value: "romance", label: "Romance" },
  { value: "thriller", label: "Thriller & Polar" },
  { value: "bien-etre", label: "Bien-être & Santé" },
  { value: "developpement-personnel", label: "Développement personnel" },
  { value: "spiritualite", label: "Spiritualité & Religion" },
  { value: "essai", label: "Essai" },
  { value: "biographie", label: "Biographie" },
  { value: "histoire", label: "Histoire" },
  { value: "jeunesse", label: "Jeunesse" },
  { value: "poesie", label: "Poésie" },
  { value: "art", label: "Art & Culture" },
  { value: "cuisine", label: "Cuisine" },
  { value: "general", label: "Autre" },
];

export const recoGenreLabel = (value) =>
  RECO_GENRES.find((g) => g.value === value)?.label || value;

const CHUNK = 2 * 1024 * 1024;
export const uploadEbook = async (extractId, file, onProgress) => {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  let res;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId); fd.append("index", i); fd.append("total", total); fd.append("filename", file.name);
    fd.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    res = await api.post(`/admin/ebooks/${extractId}/chunk`, fd, { withCredentials: true, headers: { "Content-Type": "multipart/form-data" } });
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return res.data;
};
export const fetchEbook = (token) => api.get(`/ebook/${token}`).then(r => r.data);
export const ebookUrl = (token, path) => `${API}/ebook/${token}/${path}`;
export const fetchLaunchOffer = () => api.get("/launch-offer").then(r => r.data);
export const unlockLaunchOffer = (sessionId) => api.post("/launch-offer/unlock", { session_id: sessionId }).then(r => r.data);
export const fetchPayConfig = (slug) => api.get("/payments/config", { params: { slug } }).then(r => r.data);
export const initPayment = (body) => api.post("/payments/init", body).then(r => r.data);
export const fetchPayment = (tx) => api.get(`/payments/${tx}`).then(r => r.data);
const fmtXaf = (n) => `${n.toLocaleString("fr-FR").replace(/\u202f|\u00a0/g, " ")} F CFA`;
export const discountLabel = (label, pct) => {
  if (!label) return label;
  const out = label.replace(/(\d[\d\s\u00a0\u202f.]*?)\s*(?:F\s*CFA|FCFA|XAF)/i, (_, n) => fmtXaf(Math.max(5, Math.round((Number(n.replace(/\D/g, "")) * (100 - pct)) / 100 / 5) * 5)));
  return out.replace(/(\d+(?:[.,]\d{1,2})?)\s*€/, (_, n) => `${((Number(n.replace(",", ".")) * (100 - pct)) / 100).toFixed(2).replace(".", ",")} €`);
};
